var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorporateFare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 24,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .549h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.365 21.126v-17.5h9.5v4h9.77v13.5H2.364Zm1.5-1.5h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm0-4h6.5v-2.5h-6.5v2.5Zm8 12h8.27v-10.5h-8.27v10.5Zm2.192-6.5v-1.5h3.693v1.5h-3.693Zm0 4v-1.5h3.693v1.5h-3.693Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateFare);
export default __webpack_public_path__ + "static/media/corporate_fare.7e9fb83230102feeeb763524ce4af245.svg";
export { ForwardRef as ReactComponent };